import React, { FC, memo, PropsWithChildren } from "react";
import useTabPanel from "./index.hooks";
import { Box, Fade } from "@material-ui/core";

type TabPanelProps = {
  index: any;
  value: any;
};

const TabPanel: FC<PropsWithChildren<TabPanelProps>> = (props) => {
  const { styles, classes, atomicStyles } = useTabPanel();

  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${props.index}`}
      aria-labelledby={`simple-tab-${props.index}`}
    >
      <Box p={3} display={props.value === props.index ? "block" : "none"}>
        {props.children}
      </Box>
    </div>
  );
};

export default memo(TabPanel);
